import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "context/AuthProvider";
import { RouterComponent } from "components/RouterComponent";
import { refreshAccessToken } from "./lib/tokenUtils";
import { REFRESH_TOKEN_THRESHOLD } from "./assets/constants/Constants";

// styles
import "assets/css/bootstrap.css";
import "assets/css/main.css";
import "assets/css/fonts.css";

const isLandingPage = window.location.pathname === "/" || window.location.pathname === "/index.html";

if (isLandingPage) {
  // On landing page — hide the React root, show static HTML content
  const root = document.getElementById("root");
  if (root) root.style.display = "none";

} else {
  // On all other routes (/login-page, /signup-page, /home-page etc.)
  // Hide the static landing page content, mount React
  const landingPage = document.querySelector(".landing-page");
  if (landingPage) landingPage.style.display = "none";

  const staticNavbar = document.querySelector(".new-navbar");
  if (staticNavbar) staticNavbar.style.display = "none";

  // ⭐ STEP 2 — Token refresh logic
  if (localStorage.getItem("tokenExpireTime")) {
    const expiredTime = localStorage.getItem("tokenExpireTime");
    const currentTime = Math.floor(Date.now() / 1000);
    let tokenRefreshTime = expiredTime - currentTime;

    if (tokenRefreshTime < REFRESH_TOKEN_THRESHOLD) {
      refreshAccessToken(localStorage.getItem("JWToken"));
    }
  }

  // ⭐ STEP 3 — Mount React ONLY for /app and other routes
  ReactDOM.render(
    <AuthProvider>
      <BrowserRouter>
        <RouterComponent />
      </BrowserRouter>
    </AuthProvider>,
    document.getElementById("root")
  );
}